// extracted by mini-css-extract-plugin
export default {"paginationContainer":"PaginationV2_paginationContainer__KtupV"};